import axios from "axios";
import { Auth } from "aws-amplify";

import Config from "../../config";

axios.defaults.headers.common["Content-Type"] =
  "application/json;charset=UTF-8";

const update_master = (data) => {
  return (dispatch, getState) => {
    return Auth.currentSession()
      .then((session) => {
        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: "Bearer " + token } };

        return axios
          .put(
            `${Config.API_BASE_URL}/bp/admin/replace-${data.prefix}-responsible`,
            data,
            config
          )
          .then((response) => {
            return response;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };
};

export default update_master;
